import React from "react";
import { Icon } from "./icons-props";

const ArchiveIcon: Icon = ({
  height = 18,
  width = 20,
  color = "#212121",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6728 7.57749C12.3473 7.25206 11.8197 7.25206 11.4942 7.57749C11.1688 7.90293 11.1688 8.43057 11.4942 8.756L12.155 9.41675H6.66683C6.20659 9.41675 5.8335 9.78984 5.8335 10.2501C5.8335 10.7103 6.20659 11.0834 6.66683 11.0834H12.155L11.4942 11.7442C11.1688 12.0696 11.1688 12.5972 11.4942 12.9227C11.8197 13.2481 12.3473 13.2481 12.6728 12.9227L14.7561 10.8393C15.0815 10.5139 15.0815 9.98626 14.7561 9.66083L12.6728 7.57749Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 0.666748C2.67045 0.666748 2.03457 0.93014 1.56573 1.39898C1.09689 1.86782 0.833496 2.50371 0.833496 3.16675V14.8334C0.833496 15.4965 1.09689 16.1323 1.56573 16.6012C2.03457 17.07 2.67045 17.3334 3.3335 17.3334H16.6668C17.3299 17.3334 17.9658 17.07 18.4346 16.6012C18.9034 16.1323 19.1668 15.4965 19.1668 14.8334V5.66675C19.1668 5.00371 18.9034 4.36782 18.4346 3.89898C17.9658 3.43014 17.3299 3.16675 16.6668 3.16675H9.61281L8.19354 1.03783C8.03898 0.805999 7.77879 0.666748 7.50016 0.666748H3.3335ZM2.74424 2.57749C2.90052 2.42121 3.11248 2.33341 3.3335 2.33341H7.05418L8.47345 4.46233C8.62801 4.69416 8.8882 4.83342 9.16683 4.83342H16.6668C16.8878 4.83342 17.0998 4.92121 17.2561 5.07749C17.4124 5.23377 17.5002 5.44573 17.5002 5.66675V14.8334C17.5002 15.0544 17.4124 15.2664 17.2561 15.4227C17.0998 15.579 16.8878 15.6667 16.6668 15.6667H3.3335C3.11248 15.6667 2.90052 15.579 2.74424 15.4227C2.58796 15.2664 2.50016 15.0544 2.50016 14.8334V3.16675C2.50016 2.94573 2.58796 2.73377 2.74424 2.57749Z"
        fill={color}
      />
    </svg>
  );
};

export default ArchiveIcon;
